import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { User } from '../models/user';
import { map } from 'rxjs/operators';
import { Tournament } from '../models/tournament';
import { TournamentTeamUser } from '../models/tournament-team-user';
import { LeaguePlayer } from '../models/league-player';

@Injectable({providedIn: 'root'})
export class PublicUserApi {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getById(userId: number): Promise<User> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/public_user/${userId}/`).pipe(
      map(result => User.toFront(result))
    ).toPromise();
  }

  getTournaments(userId: number, leagueId: number): Promise<Tournament[]> {
    const params = new HttpParams().set('league_id', leagueId.toString());
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/public_user/${userId}/tournaments/`, {params}).pipe(
      map(result => Tournament.toFront(result))
    ).toPromise();
  }

  getTournamentUser(userId: number, seasonId: number): Promise<TournamentTeamUser> {
    const params = new HttpParams().set('season_id', seasonId.toString());
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/public_user/${userId}/tournament_user/`, {params}).pipe(
      map(result => TournamentTeamUser.toFront(result))
    ).toPromise();
  }

  getLeaguePlayer(userId: number, leagueId: number): Promise<LeaguePlayer> {
    const params = new HttpParams().set('league_id', leagueId.toString());
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/public_user/${userId}/league_player/`, {params}).pipe(
      map(result => LeaguePlayer.toFront(result))
    ).toPromise();
  }
}
